import assertOkResponseCode from '../assertOkResponseCode';
import encodeQueryParams from '../encodeQueryParams';

const API_URL = 'https://api.wise.com/v1/comparisons/provider';

function fetchProviderRoutes(provider, sourceCurrency, sendAmount) {
  const query = encodeQueryParams({
    sourceCurrency,
    sendAmount,
  });

  return fetch(`${API_URL}/${provider}${query}`, { method: 'GET' })
    .then(assertOkResponseCode)
    .then((response) => response.json());
}

export default fetchProviderRoutes;
